import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Editor, EditorConfig } from '../../models/editor.model';
import { GetSignatureService } from '../../services/get-signature-service';
// Import all Froala Editor plugins.
import 'froala-editor/js/plugins.pkgd.min.js';

// Import a single Froala Editor plugin.
import 'froala-editor/js/plugins/align.min.js';

// Import a Froala Editor language file.
// import 'froala-editor/js/languages/de.js';


@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.css']
})
export class TextEditorComponent implements OnInit {
  @Input() element: Editor = new Editor();
  @Input() config: EditorConfig;
  showEditor: boolean = false;
  @Output() onSave: EventEmitter<Editor> = new EventEmitter<Editor>();
  @Output() onCancel: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onChange: EventEmitter<Editor> = new EventEmitter<Editor>();
  options: Object = {
     //   pluginsEnabled: ['audio', 'align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'embedly', 'emoticons', 'entities', 'file', 'fontAwesome', 'fontFamily', 'fontSize', 'fullscreen', 'image', 'imageTUI', 'imageManager', 'inlineStyle', 'inlineClass', 'lineBreaker', 'lineHeight', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quickInsert', 'quote', 'save', 'table', 'url', 'video', 'wordPaste'],
       pluginsEnabled: ['audio', 'align', 'charCounter', 'codeBeautifier', 'colors', 'draggable', 'embedly', 'emoticons', 'entities', 'file', 'fontAwesome', 'fontFamily', 'fontSize', 'fullscreen', 'image', 'imageTUI', 'imageManager', 'inlineStyle', 'inlineClass', 'lineBreaker', 'lineHeight', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quickInsert', 'quote', 'save', 'table', 'url', 'video', 'wordPaste'],
       toolbarButtons: {
            'moreText': {
                 'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
            },
            'moreParagraph': {
                 'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
            },
            'moreRich': {
                 'buttons': ['insertLink', 'insertAudio', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR']
            },
            'moreMisc': {
                 'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
                 'align': 'right',
                 'buttonsVisible': 2
            }
       },
       heightMin: 200,
       helpSets: [{
            title: 'Inline Editor',
            commands: [
                 { val: 'OSkeyE', desc: 'Show the editor' }
            ]
       },
       {
            title: 'Common actions',
            commands: [
                 { val: 'OSkeyC', desc: 'Copy' },
                 { val: 'OSkeyX', desc: 'Cut' },
                 { val: 'OSkeyV', desc: 'Paste' },
                 { val: 'OSkeyZ', desc: 'Undo' },
                 { val: 'OSkeyShift+Z', desc: 'Redo' },
                 { val: 'OSkeyK', desc: 'Insert Link' },
                 { val: 'OSkeyP', desc: 'Insert Image' }
            ]
       },
       {
            title: 'Basic Formatting',
            commands: [
                 { val: 'OSkeyA', desc: 'Select All' },
                 { val: 'OSkeyB', desc: 'Bold' },
                 { val: 'OSkeyI', desc: 'Italic' },
                 { val: 'OSkeyU', desc: 'Underline' },
                 { val: 'OSkeyS', desc: 'Strikethrough' },
                 { val: 'OSkey]', desc: 'Increase Indent' },
                 { val: 'OSkey[', desc: 'Decrease Indent' }
            ]
       },
       {
            title: 'Quote',
            commands: [
                 { val: 'OSkey\'', desc: 'Increase quote level' },
                 { val: 'OSkeyShift+\'', desc: 'Decrease quote level' }
            ]
       },
       {
            title: 'Image / Video',
            commands: [
                 { val: 'OSkey+', desc: 'Resize larger' },
                 { val: 'OSkey-', desc: 'Resize smaller' }
            ]
       },
       {
            title: 'Table',
            commands: [
                 { val: 'Alt+Space', desc: 'Select table cell' },
                 { val: 'Shift+Left/Right arrow', desc: 'Extend selection one cell' },
                 { val: 'Shift+Up/Down arrow', desc: 'Extend selection one row' }
            ]
       },
       {
            title: 'Navigation',
            commands: [
                 { val: 'OSkey/', desc: 'Shortcuts' },
                 { val: 'Alt+F10', desc: 'Focus popup / toolbar' },
                 { val: 'Esc', desc: 'Return focus to previous position' }
            ]
       }],
       imageAllowedTypes: ['jpeg', 'jpg', 'png'],
       imageEditButtons: ['imageReplace', 'imageAlign', 'imageCaption', 'imageRemove', 'imageAlt'],
       audioInsertButtons: ['audioBack', '|', 'audioByURL', 'audioUpload'],
       audioEditButtons: ['audioReplace', 'audioRemove', '|', 'audioAlign'],
       audioAllowedTypes: ['mp3', 'mpeg'],
       htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
       events: {
            'blur': () => {
                 console.log(this.element);
                 this.onChange.emit(this.element);
            },
            'initialized': function () {

            },
            'image.beforeUpload': function (e, editor, images) {

                 // Return false if you want to stop the image upload.
            },
            'image.uploadedToS3': function (e, editor, link, key, response) {

            },
            'image.error': function (e, editor, error, response) {

                 if (error) {
                      console.log(error);
                 }
            },
            'file.beforeUpload': function (e, editor, images) {

            },
            'file.uploadedToS3': function (e, editor, link, key, response) {

            },
            'file.error': function (e, editor, error, response) {

                 if (error) {
                      console.log(error);
                 }
            },
            'video.beforeUpload': function (e, editor, images) {

            },
            'video.uploadedToS3': function (e, editor, link, key, response) {
            },
            'video.uploaded': function (e, editor, response) {
                 // Video was uploaded to the server.
            },
            'video.error': function (e, editor, error, response) {

                 if (error) {
                      console.log(error);
                 }
            }
       },
       fontFamily: {
            "Roboto,sans-serif": 'Roboto',
            "Oswald,sans-serif": 'Oswald',
            "Montserrat,sans-serif": 'Montserrat',
       },
       htmlAllowedAttrs:
            ['controlsList', 'controls', 'accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap']
       , attribution: false,
       videoDefaultDisplay: 'inline',
       key: environment.froalaKey

  }
  constructor(private getSignature: GetSignatureService) { }

  ngOnInit() {
       this.getSignature.get().subscribe(
            ({ data: { image, video, file, audio } }) => {
                 console.log(image, video, file);
                 this.options = {
                      ...this.options,
                      imageUploadToS3: image,
                      fileUploadToS3: file,
                      videoUploadToS3: video,
                      audioUploadToS3: audio
                 };
                 this.showEditor = true;
            });
  }
  save() {
       this.onSave.emit(this.element);
  }
  cancel() {
       this.onCancel.emit(true);
  }

  ngAfterViewInit() {
       if (this.config === undefined) {
            this.config = new EditorConfig();
       }
  }
}
